import { createI18n, LocaleMessages, VueMessageType } from 'vue-i18n';

interface TranslationKey {
    [k: string]: string;
}

export interface TranlationStructure {
    [k: string]: TranlationStructure | string;
}


export const toObject = (arr: TranslationKey[], key: string, labelKey: string) :TranlationStructure => {
    const result: TranlationStructure = {};
    (arr || []).forEach(val => {
        const label = (val[labelKey] || '');
        const keys = (val[key] || '').split('.');
        let searchingIn = result;
        keys.slice(0, -1)
            .forEach(k => {
                if (!searchingIn[k]) {
                    searchingIn[k] = {};
                }
                searchingIn = searchingIn[k] as TranlationStructure;
            });
        searchingIn[keys[keys.length - 1]] = label;
    });
    return result;
};


function loadLocaleMessages(): LocaleMessages<VueMessageType>  {
    const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: any = {};
    locales.keys()
        .forEach(key => {
            const matched = key.match(/([A-Za-z0-9-_]+)\./i);
            if (matched && matched.length > 1) {
                const locale = matched[1];
                messages[locale] = toObject(locales(key), 'nom', 'libelle');
            }
        });
    return messages;
}


const i18n = createI18n({
    locale: 'fr',
    fallbackLocale: 'en',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    messages: loadLocaleMessages(),
});

export default i18n;
